import { getLanguage } from 'common/Utils/LocalStorageUtilities'
import { getDate, getHour } from 'common/Utils/StringUtilities'
import OrganizationFlag from 'pages/Orders/OrganizationFlag'
import RealShipmentDate from 'pages/Orders/RealShipmentDate'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import PartIncidence from './PartIncidence'

export const OrderIncidence = ({ t, incidence, openedOrderIds, handleToggleOrder, managers, rowIndex }) => {
	const { order, items } = incidence

	const isOrderExpanded = openedOrderIds.includes(order.id)
	const iconClassName = isOrderExpanded ? 'fs-2 cursor-pointer bx bx-chevron-up' : 'fs-2 cursor-pointer bx bx-chevron-down'
	const incidencesCount = items.reduce((acc, item) => acc + item.incidences.length, 0)
	const manager = managers.find((manager) => manager.id === order.organization.managerId)
	const dateCreation = getDate(order?.creationDate, getLanguage())
	const dateCreationHour = getHour(order?.creationDate)
	return (
		<div className='d-flex flex-column'>
			<div className={`${rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-150'} w-100 my-1 mx-2 p-4 rounded d-flex flex-row align-items-center`}>
				<span className='col-1'><i onClick={() => { handleToggleOrder(order.id) }} className={iconClassName} ></i></span>
				<span className='col-1'><Link to={`order/${incidence.order.id}`}>{incidence.order.id}</Link></span>
				<span className='col'><div className='d-flex flex-column'><span>{dateCreation}</span><span>{dateCreationHour}</span></div></span>
				<span className='col'><span className={`${incidence.orderSolved ? 'rounded-pill bg-green text-white' : 'rounded-pill bg-red text-white'}`}>{incidence.orderSolved ? t('solved', { ns: 'naming' }) : t('no-solved', { ns: 'naming' })}</span></span>
				<span className='col'>
					<OrganizationFlag
						country={order.shippingAddress?.country?.toLowerCase() || ''}
						organizationName={order.organization.organizationName || ''}
						firstName={order.shippingAddress.firstName || ''}
						lastName={order.shippingAddress.lastName || ''}
						userId={order.accountId || ''}
					/>
				</span>
				<span className='col'>{`${manager?.personalInformation?.firstName} ${manager?.personalInformation?.lastName}`}</span>
				<span className='col'>
					<RealShipmentDate date={order.estimatedShipmentDate} realDate={order.deliveryDate} />
				</span>
				<span className='col-1'><div className='rounded-pill bg-secondary text-white w-25 text-center'>{incidencesCount}</div></span>
			</div>
			<div className='ms-4'>
				{isOrderExpanded && (
					items.map((item, index) => (
						<div key={index}>
							<PartIncidence item={item} />
						</div>
					))
				)}
			</div>
		</div>
	)
}

OrderIncidence.propTypes = {
	t: PropTypes.func,
	incidence: PropTypes.object,
	openedOrderIds: PropTypes.array,
	handleToggleOrder: PropTypes.func,
	managers: PropTypes.array,

}

const mapStateToProps = (state) => ({
	managers: state.Users.managers,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderIncidence))
